<template>
  <data-table
    api-url="/admin/squadre"
    :columns="columns"
    :editFormData="teamsData"
    :canDelete="false"
    :defaultFilter="false"
    @editError="editError"
  >
    <template slot="filters">
      <b-form-input
        v-model="filters.name"
        placeholder="Nome squadra"
        class="inline mr-3"
      />
      <!--b-form-input
        v-model="filters.stadium"
        placeholder="Stadio"
        class="inline mr-3"
      /-->
    </template>

    <template slot="edit-modal-body">
      <b-form-group label="Nome">
        <multiselect
          v-model="teamsData.stadium"
          :options="stadiums"
          placeholder="Seleziona uno stadio"
          label="nome"
          track-by="id"
          :internal-search="false"
          :loading="stadiumsLoading"
          @search-change="searchStadiums"
        />
      </b-form-group>
    </template>
  </data-table>
</template>

<script>
import axios from "axios";
import DataTable from "./DataTable.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "AdminTeams",
  components: { DataTable, Multiselect },

  data() {
    return {
      columns: [
        { key: "id", label: "ID", sortable: true },
        { key: "name", label: "Nome", sortable: true },
        //    { key: "stadio", label: "Stadio", sortable: true },
        //    { key: "actions", label: "Azioni" },
      ],
      teamsData: {
        stadium: null,
      },
      stadiumsLoading: false,
      stadiums: [],
      filters: {
        homeTeam: "",
        awayTeam: "",
        stadium: "",
      },
    };
  },

  methods: {
    editError(err) {
      if (err.response && err.response.data.error) {
        this.$store.commit("msgPush", {
          status: 0,
          msg: err.response.data.error,
        });
      }
    },

    searchStadiums(query) {
      this.stadiumsLoading = true;
      axios
        .get("/stadi", {
          params: {
            additional_filters: { stadium: query },
            per_page: 300,
          },
        })
        .then((res) => {
          this.stadiums = res.data.data;
          this.stadiumsLoading = false;
        })
        .catch(() => {
          this.stadiumsLoading = false;
          this.$store.commit("msgPush", {
            status: 0,
            msg: "Qualcosa è andato storto, prova a ricaricare la pagina",
          });
        });
    },
  },

  watch: {
    filters: {
      handler() {
        this.$root.$emit("data-table::filter", this.filters);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.pac-container {
  z-index: 1051 !important;
}
</style>
